import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  formOnlineData: {},
  numberOfTickets: [],
  formDataOnlineform: [],
  FormDataRequiredFields: [],
  registrationForm: [{}],
  products: [],
  varients: {},
  selectedValue: [],
  previousSelectedValue: [],
  currentSelectIndex: "",
  FormDataReservation: []
};

export const formSlice = createSlice({
  name: "forms",
  initialState,
  reducers: {
    setCounterTicket: (state, payload) => {
      state.numberOfTickets = payload.payload;
      return state;
    },
    setFormOnlineData: (state, { payload }) => {
      state.formOnlineData = payload;
      return state;
    },
    setFormReservationData: (state, { payload }) => {
      state.formDataOnlineform = payload;
      return state;
    },
    setForms: (state, { payload }) => {
      state.registrationForm = payload;
      return state;
    },
    setResetForms: (state, { payload }) => {
      state.registrationForm = [];
      return state;
    },
    setFormDataRequiredFields: (state, { payload }) => {
      state.FormDataRequiredFields = payload;
      return state;
    },
    setProducts: (state, { payload }) => {
      console.log("payload state", payload);
      return { ...state, products: payload };
    },
    setTotalProducts: (state, { payload }) => {
      return { ...state, totalProducts: payload };
    },
    setVarients: (state, action) => {
      return { ...state, varients: action.payload };
    },
    setVarientPrice: (state, action) => {
      const { productIndex, price } = action.payload;
      state.varients = {
        ...state.varients,
        [productIndex]: {
          ...state.varients[productIndex],
          price
        }
      };
      return state;
    },
    setSelectedValue: (state, action) => {
      const {
        data,
        productIndex,
        productTitle,
        dropdownIndex,
        type,
        ticketIndex
      } = action.payload;
      state.selectedValue = data;
      // find the object depends on dropdownIndex and ticketIndex we need it to change on varients counter value depends on productIndex
      const selectedValueIndex = state.selectedValue?.map(item => {
        return item[productTitle]?.find(
          item =>
            item.indexSelected === dropdownIndex &&
            item.ticketIndex === ticketIndex
        );
      });
      const changeQuantity =
        data &&
        state?.varients?.[productIndex]?.variantsInfo?.map(varient => {
          console.log("QWQWQWQvarient", varient);
          const selected = selectedValueIndex?.[0];
          const isSelectedOption = varient.option === selected?.value;

          // For openAmount variants, persist the user-entered amount into the variant
          // so calculations based on `variant.amount` don't stay 0.
          let updatedVarient = varient;
          if (
            isSelectedOption &&
            type !== "remove" &&
            varient?.openAmount &&
            selected?.amount !== undefined &&
            selected?.amount !== null
          ) {
            updatedVarient = {
              ...varient,
              amount: Number(selected.amount) || 0,
              price: Number(selected.amount) || 0
            };
          }

          // When switching variants, decrement counterValue of the previous variant
          if (
            !isSelectedOption &&
            selected?.previousValue &&
            varient.option === selected.previousValue
          ) {
            return {
              ...updatedVarient,
              counterValue:
                varient?.counterValue > 0 ? varient?.counterValue - 1 : 0
            };
          }

          // check if the object value is equal to the option and update counterValue
          if (
            isSelectedOption &&
            type !== "remove" &&
            selected?.previousValue !== selected?.value
          ) {
            return {
              ...updatedVarient,
              counterValue: (varient?.counterValue || 0) + 1
            };
            // minus from counterValue if the type is remove (came from ticket inside decrement button) if the user removes one of the dropdowns
          } else if (isSelectedOption && type === "remove") {
            return {
              ...updatedVarient,
              counterValue: varient?.counterValue - 1
            };
          }
          // if we have no match just return the item as it is
          return { ...updatedVarient };
        });
      // Replace the product with new array of products after adding/removing a variant
      const replaceOldData = {
        ...state?.varients,
        [productIndex]: {
          ...state.varients?.[productIndex],
          variantsInfo: changeQuantity
        }
      };
      state.varients = replaceOldData;
      return state;
    },
    setFormDataReservation: (state, action) => {
      return { ...state, FormDataReservation: action.payload };
    },
    resetAction: state => {
      return { ...state, selectedValue: [], FormDataReservation: [] };
    },
    setCurrentSelectIndex: (state, payload) => {
      state.currentSelectIndex = payload.payload;
      return state;
    }
  }
});

export const { setCounterTicket, setCurrentSelectIndex } = formSlice.actions;
export default formSlice.reducer;
